import React from 'react';
import HomeFactSingleItem from '../../../../components/HomeFactSingleItem/HomeFactSingleItem';

const FactArea = () => {
   return (
      <>
         <section className="tp-fact-area theme-dark-bg pt-75 pb-20">
            <div className="container">
               <div className="row">
                  <HomeFactSingleItem icon="shuttle" fact_num="2025" title="Projet terminé" />
                  <HomeFactSingleItem icon="broom" fact_num="3050" title="Nettoyeur dédié" />
                  <HomeFactSingleItem icon="selection" fact_num="8205" title="Client satisfait" />
                  <HomeFactSingleItem icon="badge" fact_num="56" title="Prix local" />
               </div>
            </div>
         </section>
      </>
   );
};

export default FactArea;